// Flexar: the app opened from the iPhone Home Screen runs full screen, down under the home
// indicator, yet WebKit reports env(safe-area-inset-*) = 0 unless the page opts into
// viewport-fit=cover — so the composer sat on the indicator. The page opts in only there and only
// upright. In plain Safari, and on its side, WebKit keeps the page clear of the notch by itself;
// with cover it would stop, and every edge would need an inset of its own (on its side an iPhone
// would also cross into the tablet layout). Upright in the web app the side insets are 0 and the
// default status bar keeps the page below it, so only the bottom takes an inset: the bottom
// surfaces take `max(<padding>, env(safe-area-inset-bottom))`, a padded sheet footer adds env().
const COVER = 'viewport-fit=cover';
const UPRIGHT = '(orientation: portrait)';

/** Opened from the Home Screen as a web app (iOS: navigator.standalone; elsewhere display-mode). */
export function isHomeScreenWebApp(win: Window = window): boolean {
  const { standalone } = win.navigator as Navigator & { standalone?: boolean };
  return (
    standalone === true || win.matchMedia('(display-mode: standalone)').matches
  );
}

/** Opts the viewport into the safe area in the Home Screen web app while it is upright. */
export function fitViewportToWebApp(win: Window = window): void {
  const meta = win.document.querySelector<HTMLMetaElement>(
    'meta[name="viewport"]',
  );
  if (!meta || !isHomeScreenWebApp(win)) return;
  const base = meta.content;
  const upright = win.matchMedia(UPRIGHT);
  const apply = () => {
    meta.content = upright.matches ? `${base}, ${COVER}` : base;
  };
  apply();
  upright.addEventListener('change', apply);
}
